import type { ReactNode } from 'react';

export interface LwPageChromeBreadcrumb {
  label: string;
  onSelect?: () => void;
}

export interface LwPageChromeProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  breadcrumbs?: readonly LwPageChromeBreadcrumb[];
  actions?: ReactNode;
  className?: string;
}

/** Canonical page heading for the id-routed internal portal. */
export function LwPageChrome({
  eyebrow,
  title,
  description,
  breadcrumbs = [],
  actions,
  className
}: LwPageChromeProps) {
  return (
    <header className={`lw-page-chrome${className ? ` ${className}` : ''}`}>
      {breadcrumbs.length > 0 && (
        <nav className="lw-page-chrome__breadcrumbs" aria-label="Breadcrumb">
          <ol>
            {breadcrumbs.map((breadcrumb, index) => {
              const current = index === breadcrumbs.length - 1;
              return (
                <li key={`${breadcrumb.label}-${index}`}>
                  {breadcrumb.onSelect && !current ? (
                    <button type="button" onClick={breadcrumb.onSelect}>{breadcrumb.label}</button>
                  ) : (
                    <span aria-current={current ? 'page' : undefined}>{breadcrumb.label}</span>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      )}
      <div className="lw-page-chrome__row">
        <div className="lw-page-chrome__copy">
          {eyebrow && <div className="lw-caps-label">{eyebrow}</div>}
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
        {actions && <div className="lw-page-chrome__actions">{actions}</div>}
      </div>
    </header>
  );
}
